import { PersonStore } from "../../store/modules/person";
import { ConfigStore } from "../../store/modules/config";
import { PersonInfoModel } from "models/person/personInfoModel";
import { NotifyData } from "../../data/notifyData";
import { getPeriodOfDay } from "../../utilities/index";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import IAuthService from "../../services/auth/IAuthService";
import { DiTokens } from "../../services/diTokens";
import { container } from "@/inversify.config";

export class MainNavigationVue extends Vue {

  /**Стор авторизации */
  get authService(): IAuthService {
    return container.get<IAuthService>(DiTokens.AuthService);
  }
  /** Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /** Стор личных данных */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /** Список ссылок в меню */
  links: Array<any> = [
    { title: this.$i18n.t("main.header.links.main"), url: "/", exact: true },
    { title: this.$i18n.t("main.header.links.payments"), url: "/payments" },
    { title: this.$i18n.t("main.header.links.history"), url: "/operations" },
    { title: this.$i18n.t("main.header.links.settings"), url: "/settings" },
    {
      title: this.$i18n.t("main.header.links.authHistory"),
      url: "/authHistory"
    }
  ];

  /** Признак видимости правого меню */
  isMenuOpen: boolean = false;

  /** Признак видимости левого меню */
  isLeftSideOpen: boolean = true;

  /**Приветсвие */
  greeting: string =
    i18n.t("main.header.greetings." + getPeriodOfDay()).toString() ||
    "Здравствуйте";

  /** Данные пользователя */
  get personInfo(): PersonInfoModel {
    return this.personStore.personInfo;
  }

  /** Уведомления */
  get notifications(): Array<NotifyData> {
    return this.personStore.notifyData;
  }

  get newNotifiesCount(): number {
    return this.personStore.newNotifiesCount;
  }
  get windowWidth(): number {
    return this.windowWidthCalc;
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  /** Закрытие левого окна меню */
  get leftSideHide(): () => void {
    return () => {
      this.isLeftSideOpen = false;
    };
  }

  /** Переход на главную страницу */
  get pushMain(): () => void {
    return () => {
      if (this.$router.currentRoute.fullPath !== "/") this.$router.push("/");
    };
  }

  /** Меняет признак видимости левого меню */
  get hideShowSidebar(): () => void {
    return () => {
      if (this.$route.path != "/") this.isLeftSideOpen = !this.isLeftSideOpen;
    };
  }

  /** Меняет признак видимости правого меню */
  hideShowMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**Переход к странице уведомлений */
  get toNotifications(): () => void {
    return () => {
      this.$router.push("/notifications");
    };
  }

  /**Выход из системы */
  async logout() {
    await this.authService.logout();
  }
}
